import { ACCEPT_VIDEO_FILETYPES } from 'application/pages/constants';

const acceptedVideoExtensions = Object.values(ACCEPT_VIDEO_FILETYPES)
  .flat()
  .map((extension) => extension.toLowerCase());

export const filterAcceptedVideoFiles = (files: File[]) =>
  files.filter((file) => acceptedVideoExtensions.some((extension) => file.name.toLowerCase().endsWith(extension)));
